import type { ReactNode } from "react";

interface Props {
  alertBar: ReactNode;
  viewscreen: ReactNode;
  commandBar: ReactNode;
  children: ReactNode; // floating panels
}

export function BridgeLayout({ alertBar, viewscreen, commandBar, children }: Props) {
  return (
    <div className="bridge-layout">
      {/* Alert bar — fixed top */}
      <div className="bridge-alert-bar">{alertBar}</div>

      {/* Viewscreen — fixed center, 16:9 */}
      <div className="bridge-viewscreen">{viewscreen}</div>

      {/* Floating panels layer — pointer-events: none, panels themselves are auto */}
      <div className="bridge-panels">{children}</div>

      {/* Command input — fixed bottom */}
      <div className="bridge-command-bar">{commandBar}</div>
    </div>
  );
}
